<template>
    <div>
        <h1 @click="testGetterSSV">{{message}}</h1>
    </div>
    
    <div class="container">
        <ChoixBeneficiareVitale />
        <!--<AcquisDroitIntegre />-->
    </div>
</template>
<style scoped>
    .container {
        display: flex;
        justify-content: center;
    }

    h1{
        display: flex;
        justify-content: center; 
        margin-bottom: 60px;
    }
</style>
<script>
    import { defineComponent } from 'vue';
    import ChoixBeneficiareVitale from './ChoixBeneficiareVitale.vue';
    import AcquisDroitIntegre from './AcquisDroitIntegre.vue';
    import RequestManager from '../script/request';


    export default defineComponent({
        components: {
            //Les composants
            ChoixBeneficiareVitale,
            AcquisDroitIntegre
        },
        data: function () {
            return {
                message: 'Lire Carte Vitale'
            }
        },

        computed: {

        },

        methods: {
            testGetterSSV() {
                //alert("On test !!!");
                //alert(JSON.stringify(this.$store.getters["SSV/getCarteVitale"]));
                //RequestManager.
            }

        },

        props: {

        },
        
        created() {

        }

    });
</script>